"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _config = require("./config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks
 * owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */
var appendCustomerURL = function appendCustomerURL(url) {
  if (process.env.REACT_APP_CUSTOMER && process.env.REACT_APP_CUSTOMER !== '') {
    return "/".concat(process.env.REACT_APP_CUSTOMER).concat(url);
  }

  return url;
};

var getConfig = function getConfig() {
  if (process.env.REACT_APP_ENV) {
    var reactAppEnv = process.env.REACT_APP_ENV.toLowerCase();

    if (reactAppEnv === 'qa') {
      return _config.configqa;
    }

    if (reactAppEnv === 'prod') {
      return _config.configprod;
    }
  } // default for local environment


  return _config.configqa;
};

var getAPIGatewayURL = function getAPIGatewayURL() {
  if (process.env.REACT_APP_API_URL) {
    return _lodash["default"].trimEnd(process.env.REACT_APP_API_URL, '/');
  } // default for local environment


  return 'http://localhost:8082';
};

var getUserAPIVersion = function getUserAPIVersion() {
  if (process.env.REACT_APP_USER_API_VERSION) {
    return process.env.REACT_APP_USER_API_VERSION;
  }

  return 'v1';
};

var getRedirectURI = function getRedirectURI() {
  if (process.env.REACT_APP_SENTIENCE_REDIRECT_URI) {
    return _lodash["default"].trimEnd(process.env.REACT_APP_SENTIENCE_REDIRECT_URI, '/');
  } // default for local environment


  return 'http://localhost:3000';
};

var getSentienceEnableFlag = function getSentienceEnableFlag() {
  if (process.env.REACT_APP_SENTIENCE_ENABLE) {
    if (process.env.REACT_APP_SENTIENCE_ENABLE.toLowerCase() === 'false') {
      return false;
    }
  }

  return true;
};

var getClientID = function getClientID() {
  if (process.env.REACT_APP_SENTIENCE_CLIENT_ID) {
    return process.env.REACT_APP_SENTIENCE_CLIENT_ID;
  }

  throw new Error('Client ID is not set');
};

var getSelfService = function getSelfService() {
  if (process.env.REACT_APP_SELF_SERVICE) {
    return process.env.REACT_APP_SELF_SERVICE;
  }

  return 'true';
};

var getSentienceLoginUrl = function getSentienceLoginUrl() {
  return "".concat(getConfig().sentienceURL, "/openam/oauth2/authorize") + "?client_id=".concat(getClientID()) + "&redirect_uri=".concat(getRedirectURI(), "/callback") + '&response_mode=form_get' + '&response_type=token id_token' + '&scope=openid profile' + "&realm=".concat(getConfig().realm) + '&nonce=test' + "&selfService=".concat(getSelfService());
};

var getSupportEmail = function getSupportEmail() {
  if (process.env.REACT_APP_SUPPORT_EMAIL) {
    return process.env.REACT_APP_SUPPORT_EMAIL;
  }

  return 'swsolutionsupport@Honeywell.com';
};

var getSupportPhone = function getSupportPhone() {
  if (process.env.REACT_APP_SUPPORT_PHONE) {
    return process.env.REACT_APP_SUPPORT_PHONE;
  }

  return '+4006396841';
};

var getHelpURI = function getHelpURI() {
  if (process.env.REACT_APP_HELP_URI) {
    return process.env.REACT_APP_HELP_URI;
  }

  return 'http://localhost:3000/Default.htm';
};

var getReloadInterval = function getReloadInterval() {
  if (process.env.REACT_APP_RELOAD_INTERVAL_MS) {
    return process.env.REACT_APP_RELOAD_INTERVAL_MS;
  }

  return 15000;
};

var showRegisterAccountLink = function showRegisterAccountLink() {
  if (process.env.REACT_APP_SHOW_REGISTER_ACCOUNT_LINK) {
    if (process.env.REACT_APP_SHOW_REGISTER_ACCOUNT_LINK.toLowerCase() === 'true') {
      return true;
    }
  }

  return false;
};

var getHostname = function getHostname() {
  if (process.env.REACT_APP_HOSTNAME) {
    return process.env.REACT_APP_HOSTNAME;
  }

  return 'http://localhost:3000';
}; // export object with all functions above


var _default = {
  appendCustomerURL: appendCustomerURL,
  getConfig: getConfig,
  getAPIGatewayURL: getAPIGatewayURL,
  getUserAPIVersion: getUserAPIVersion,
  getRedirectURI: getRedirectURI,
  getSentienceEnableFlag: getSentienceEnableFlag,
  getSentienceLoginUrl: getSentienceLoginUrl,
  getSupportEmail: getSupportEmail,
  getSupportPhone: getSupportPhone,
  getHelpURI: getHelpURI,
  getReloadInterval: getReloadInterval,
  showRegisterAccountLink: showRegisterAccountLink,
  getHostname: getHostname
};
exports["default"] = _default;